import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

Vue.use(Vuex)

const { uid } = firebase.auth().currentUser || {};

const eventModule = ({ manualOnly = false } = {}) => {
  return {
    namespaced: true,
    state: {
      fetchingEvents: false,
      lastDoc: undefined,
      events: [],
    },
    getters: {
      getEventById: state => id => {
        return state.events.find(e => e.id === id);
      },
    },
    mutations: {
      setFetchingEvents (state, fetchingEvents) {
        state.fetchingEvents = fetchingEvents;
      },
      setLastDoc (state, lastDoc) {
        state.lastDoc = lastDoc;
      },
      setEvents (state, events) {
        state.events = events;
      },
      removeEventAtIndex (state, index) {
        state.events.splice(index, 1);
      },
    },
    actions: {
      async queryEvents ({ commit, state }) {
        commit('setFetchingEvents', true);
        const db = firebase.firestore();
        let query = db.collection("event_splashes")        
          .orderBy("endDate", "desc")
          .limit(28);
        if (manualOnly) {
          query = query.where('manual', '==', true);
        }
        if (state.lastDoc) {
          query = query.startAfter(state.lastDoc);
        }
        const snapshot = await query.get();
        const events = snapshot.docs.map(doc => {
          return {
            id: doc.id,
            ...doc.data(),
          }
        });
        if (snapshot.docs.length == 0) {
          commit('setLastDoc', null);
        } else {
          commit('setLastDoc', snapshot.docs[snapshot.docs.length - 1]);
        }
        commit('setFetchingEvents', false);
        return events;
      },
      async fetchEvents ({ dispatch, commit }) {
        commit('setEvents', []);
        commit('setLastDoc', null);
        const events = await dispatch('queryEvents');
        commit('setEvents', events);
      },
      async loadMore ({ dispatch, commit, state }) {
        const events = await dispatch('queryEvents');
        commit('setEvents', [...state.events, ...events]);
      },
      async deleteSplash ({ commit, state }, index) {
        const db = firebase.firestore();
        const event = state.events[index];
        commit('removeEventAtIndex', index);
        await db.doc(`event_splashes/${event.id}`).delete();
      },
    },
  };
};

export default new Vuex.Store({
  state: {
    isLoggedInUser: uid !== undefined,
    userId: uid,
    isAdmin: undefined,
    isFetchingUserData: false,
  },
  getters: {
    getEventById: (state, getters) => id => {
      return getters['manualEvents/getEventById'](id) || getters['allEvents/getEventById'](id);
    },
  },
  mutations: {
    setIsAdmin (state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setIsFetchingUserData (state, isFetchingUserData) {
      state.isFetchingUserData = isFetchingUserData;
    },
  },
  actions: {
    async fetchUserData ({ commit, state }) {
      const db = firebase.firestore();
      console.log(`fetch user data for ${state.userId}`);
      commit('setIsFetchingUserData', true);
      const doc = (await db.doc(`users/${state.userId}`).get()).data() || {};
      commit('setIsFetchingUserData', false);
      commit('setIsAdmin', doc.admin);
    },
  },
  modules: {
    allEvents: eventModule(),
    manualEvents: eventModule({ manualOnly: true }),
  },
})
